﻿if ($('.latest-properties').length > 0) {
    const mySwiper = new Swiper('.latest-properties > .list-view-wrapper > .swiper-container', {
        navigation: {
            nextEl: '.swiper-button-next',
            prevEl: '.swiper-button-prev',
        },
        slidesPerView: 3,
        spaceBetween: 20,
        centeredSlides: false,
        loop: false,
        breakpoints: {
            800: {
                slidesPerView: 2,
                spaceBetween: 20,
                centeredSlides: true,
                navigation: false,
                loop: true,
            },
            500: {
                slidesPerView: 1.3,
                centeredSlides: true,
                spaceBetween: 15,
                loop: true,
            }
        }
    });

}